<template>
  <div class="outer">
    <iframe style="width:100%;height:100%" :src='urlSrc'></iframe>
  </div>
</template>
<script>
export default {
  data(){
    return{
      urlSrc:''
    }
  },
  created(){
    this.urlSrc = this.$route.query.url
  }
}
</script>
<style lang="less" scoped>
.outer{
  width: 100%;
  height: 100%;
}
.iframe{
  width: 100%;
  height: 100%;
}
</style>